import { inject, Pipe, PipeTransform } from '@angular/core';
import { CompanyContextService } from '@skylab-angular-shared/core';

@Pipe({ name: 'sklCompanyLink' })
export class CompanyContextLink implements PipeTransform {
	private companyContextService = inject(CompanyContextService);

    public transform(url: string): string {
		return `/t/${this.companyContextService.companyContext.companyIdentityId}/${url}`
	}
}
